<template>
  <div class="party-download-panel">
    <div v-if="groups.length" class="party-download-groups">
      <section
        v-for="group in groups"
        :key="group.category"
        class="party-download-group"
      >
        <h3>{{ group.category }}</h3>
        <ul class="party-download-list">
          <li v-for="item in group.items" :key="item.entryId || item.title">
            <div class="party-download-meta">
              <strong>{{ item.title }}</strong>
              <span v-if="item.summary">{{ item.summary }}</span>
            </div>
            <button
              v-if="item.fileUrl"
              type="button"
              class="party-download-link"
              @click="front.downloadSiteFile(item.fileUrl, item.title)"
            >下载</button>
            <button v-else type="button" class="party-download-link" disabled>下载</button>
          </li>
        </ul>
      </section>
    </div>
    <p v-else class="muted-copy">暂无已发布内容，请在管理后台维护</p>
    <FrontPagination
      :page-num="front.partyListPageNum"
      :page-size="front.partyListPageSize"
      :total="front.partyListTotal"
      @change="page => front.changePartyListPage(page)"
    />
  </div>
</template>

<script>
import FrontPagination from '../common/FrontPagination.vue'

export default {
  name: 'PartyDownloadPanel',
  components: { FrontPagination },
  inject: ['front'],
  computed: {
    groups() {
      const entries = this.front.partyListItems || []
      const map = new Map()
      entries.forEach((item) => {
        const category = (item && item.category) || '其他'
        if (!map.has(category)) {
          map.set(category, [])
        }
        map.get(category).push(item)
      })
      return Array.from(map.entries()).map(([category, items]) => ({ category, items }))
    }
  }
}
</script>
